import styles from './cookiesModal.less'; export {styles};
import DefaultPage from './cookiesModal/defaultPage';
import SettingsPage from './cookiesModal/settingsPage';
import LegalPage from './cookiesModal/legalPage';
import CookieOption from '../cookieOption';

export enum PageType {
    DEFAULT,
    SETTINGS,
    LEGAL,
}

interface CookiesModalProps {
    cookieOptions: CookieOption[];
    onChangeCookieOptions: (options: CookieOption[]) => void;
}

interface CookiesModalState {
    visible: boolean;
    currentPage: PageType;
}

export default class CookiesModal extends React.Component<CookiesModalProps, CookiesModalState> {

    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            currentPage: PageType.DEFAULT,
        }

        this.onAllAgree = this.onAllAgree.bind(this);
        this.onAllDisagree = this.onAllDisagree.bind(this);
        this.onCustomizedAgree = this.onCustomizedAgree.bind(this);
    }

    show(page: PageType = PageType.DEFAULT) {
        this.setState(Object.assign(this.state, {visible: true, currentPage: page}));
    }

    hide() {
        this.setState(Object.assign(this.state, {visible: false}));
    }

    onAllAgree() {
        for (let option of this.props.cookieOptions) {
            option.setAllowed(true);
        }

        this.props.onChangeCookieOptions(this.props.cookieOptions);
        this.hide();
    }

    onAllDisagree() {
        for (let option of this.props.cookieOptions) {
            option.setAllowed(false);
        }

        this.props.onChangeCookieOptions(this.props.cookieOptions);
        this.hide();
    }

    onCustomizedAgree(options: CookieOption[]) {
        this.props.onChangeCookieOptions(options);
        this.hide();
    }

    render() {
        return (
            <>
                {this.state.visible && (
                    <div className={styles.wrapper}>
                        <div className={styles.modal}>
                            <div className={styles.head}>
                                <h2>{_('[COOKIES_MODAL] Privacy and cookies settings')}</h2>
                                <div className={styles.closeButton} onClick={() => this.hide()}>
                                    <i className="fa fa-times"/>
                                </div>
                            </div>

                            {this.state.currentPage == PageType.DEFAULT && (
                                <DefaultPage
                                    onClickAgree={this.onAllAgree}
                                    onClickDisagree={this.onAllDisagree}
                                    onClickCustomize={() => this.show(PageType.SETTINGS)}
                                    onClickLegalDetails={() => this.show(PageType.LEGAL)}
                                />
                            )}

                            {this.state.currentPage == PageType.SETTINGS && (
                                <SettingsPage
                                    cookieOptions={this.props.cookieOptions}
                                    onClickAgreeAll={this.onAllAgree}
                                    onClickAgreeSelected={this.onCustomizedAgree}
                                />
                            )}

                            {this.state.currentPage == PageType.LEGAL && (
                                <LegalPage
                                    onClickClose={() => this.show(PageType.DEFAULT)}
                                />
                            )}
                        </div>
                    </div>
                )}
            </>
        );
    }
}
